module.exports = __webpack_public_path__ + "img/message.dc8b7753.png";